/**
 * Trainer sign-up. The second surface a session-less browser is allowed to sit on.
 *
 * The guard is the same one line every auth route carries. It leaves a signed-out visitor here
 * rather than forwarding them to sign-in — `sessionRedirectFrom` knows both are legal addresses for
 * that status — and it still forwards anyone who already has a session to wherever that session
 * belongs, so a signed-in trainer cannot open a registration form.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionRedirectFrom } from '~/entities/session';
import { SignUpScreen } from '~/pages/sign-up';

export const Route = createFileRoute('/sign-up')({
  beforeLoad: () => {
    const destination = sessionRedirectFrom('/sign-up');
    // `throw: true` makes `redirect` raise the router's own Response itself. A bare `throw
    // redirect(...)` throws a non-Error, which is exactly what `only-throw-error` is there to catch.
    if (destination !== null) redirect({ to: destination, replace: true, throw: true });
  },
  component: SignUpScreen,
});
